export const TIPO_FORMA_PAGAMENTO_DESCONTO = 'DESCONTO'
// Prefixos de nome de tipo que representam cortesia/grátis
// (reconhece "CORTESIA CLIENTE", "CORTESIA TREINAMENTO", etc.)
export const PREFIXOS_FORMA_PAGAMENTO_CORTESIA = ['CORTESIA', 'GRATIS']

// Responsáveis pela autorização de cortesia (lista fixa)
export const RESPONSAVEIS_CORTESIA = ['Aleqsandros', 'Nivea']

/** FATURADO (produção). */
export const ID_TIPO_FATURADO = 6
/** CORTESIA CLIENTE (produção). */
export const ID_TIPO_CORTESIA_CLIENTE = 7
/** CORTESIA TREINAMENTO (produção). */
export const ID_TIPO_CORTESIA_TREINAMENTO = 9

export const IDS_TIPO_CORTESIA = [
  ID_TIPO_CORTESIA_CLIENTE,
  ID_TIPO_CORTESIA_TREINAMENTO,
]

export function formaPagamentoEhDesconto(formaPagamento) {
  if (!formaPagamento) return false
  const nome =
    formaPagamento?.tipo_nome ??
    formaPagamento?.tipo?.nome ??
    formaPagamento?.tipoNome
  return String(nome || '').trim().toUpperCase() === TIPO_FORMA_PAGAMENTO_DESCONTO
}

export function nomeTipoEhCortesia(nome) {
  const n = String(nome || '').trim().toUpperCase()
  if (!n) return false
  return PREFIXOS_FORMA_PAGAMENTO_CORTESIA.some((prefixo) => n.startsWith(prefixo))
}

export function formaPagamentoEhCortesia(formaPagamento) {
  if (!formaPagamento) return false
  const pagIdTipo = Number(formaPagamento?.pag_idtipo ?? 0)
  if (IDS_TIPO_CORTESIA.includes(pagIdTipo)) return true
  const nome =
    formaPagamento?.tipo_nome ??
    formaPagamento?.tipo?.nome ??
    formaPagamento?.tipoNome
  return nomeTipoEhCortesia(nome)
}

/**
 * Reserva com pagamento cortesia (embarque ou antecipado).
 * Usado só no front do acerto para zerar neto nos cálculos — não altera o banco.
 */
export function reservaTemPagamentoCortesia(reserva) {
  const listas = [
    ...(reserva?.pagamentosEmbarque || []),
    ...(reserva?.pagamentosAntecipado || []),
    ...(reserva?.pagamentos || []),
  ]

  return listas.some((pagamento) => {
    const forma =
      pagamento?.formaPagamento || pagamento?.forma || pagamento?.pagamento_forma
    if (!formaPagamentoEhCortesia(forma)) return false
    const formaValue = Number(forma?.value ?? forma?.pag_id ?? pagamento?.pag_idpagamento ?? 0)
    return formaValue > 0
  })
}

export function tipoNomeFromPagamentoTipos(pagIdTipo, tipos = []) {
  if (pagIdTipo == null || pagIdTipo === '') return null
  const tipo = (tipos || []).find((t) => String(t.id) === String(pagIdTipo))
  return tipo?.nome ?? null
}

export function enriquecerFormaPagamentoComTipoNome(formaPagamento, tipos = []) {
  if (!formaPagamento || typeof formaPagamento !== 'object') return formaPagamento
  if (formaPagamento.tipo_nome) return formaPagamento
  const tipoNome = tipoNomeFromPagamentoTipos(formaPagamento.pag_idtipo, tipos)
  if (!tipoNome) return formaPagamento
  return { ...formaPagamento, tipo_nome: tipoNome }
}

/**
 * Monta option de forma a partir do payload da API (com tipo/fornecedor quando vierem).
 */
export function montarFormaPagamentoOptionFromApi(forma, valueFallback = null) {
  const value = forma?.pag_id ?? forma?.value ?? valueFallback ?? null
  if (value == null || value === '') {
    return {
      label: 'Selecione a forma de pagamento!',
      value: null,
      pag_credito: null,
      pag_cash: null,
      pag_debito: null,
      pag_idtipo: null,
      tipo_nome: null,
      pag_taxa: null,
      pag_taxa_parcelado: null,
      pag_fornecedor_id: null,
      pag_fornecedor_nome: null,
    }
  }

  return {
    label: forma?.pag_nome || forma?.label || '',
    value,
    pag_credito: forma?.pag_credito ?? null,
    pag_cash: forma?.pag_cash ?? null,
    pag_debito: forma?.pag_debito ?? null,
    pag_idtipo: forma?.pag_idtipo ?? forma?.tipo?.id ?? null,
    tipo_nome: forma?.tipo?.nome ?? forma?.tipo_nome ?? null,
    pag_taxa: forma?.pag_taxa ?? null,
    pag_taxa_parcelado: forma?.pag_taxa_parcelado ?? null,
    pag_fornecedor_id: forma?.pag_fornecedor_id ?? forma?.fornecedor?.par_id ?? null,
    pag_fornecedor_nome:
      forma?.pag_fornecedor_nome ?? forma?.fornecedor?.pessoa?.pes_nome ?? null,
  }
}

/** Option do select de tipo (Forma de pagamento) a partir da forma. */
export function montarTipoPagamentoFromForma(forma) {
  const tipoId = forma?.pag_idtipo ?? forma?.tipo?.id ?? null
  if (tipoId == null || tipoId === '') return null
  const label = String(
    forma?.tipo?.nome ?? forma?.tipo_nome ?? forma?.tipoPagamento?.label ?? ''
  ).trim()
  return {
    value: tipoId,
    label,
  }
}

/**
 * Garante tipoPagamento + tipo_nome em um pagamento já no formato da tela.
 */
export function enriquecerPagamentoComTipoSelect(pagamento) {
  if (!pagamento || typeof pagamento !== 'object') return pagamento
  const forma = pagamento.formaPagamento || {}
  const tipo_nome =
    forma.tipo_nome ||
    pagamento.tipoPagamento?.label ||
    forma.tipo?.nome ||
    null
  const formaPagamento = {
    ...forma,
    tipo_nome: tipo_nome || null,
  }
  const tipoPagamento =
    pagamento.tipoPagamento &&
    pagamento.tipoPagamento.value != null &&
    String(pagamento.tipoPagamento.label || '').trim()
      ? pagamento.tipoPagamento
      : montarTipoPagamentoFromForma(formaPagamento)

  return {
    ...pagamento,
    formaPagamento,
    tipoPagamento,
  }
}
